import {API2_URL, NOTIFICATION_TYPE_REQUEST, NOTIFICATION_TYPE_SHOW, NOTIFICATION_TYPE_EDIT, NOTIFICATION_TYPE_CLEAR, NOTIFICATION_TYPE_FAIL} from "../store/config";
import {newNotification} from "./notifications";
import {sessionService} from "redux-react-session";
import fetch from "isomorphic-fetch";
import _ from 'lodash';
import {history} from "../store/store";

export const fetchNotificationsTypes = (page = 1) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(NotificationTypeRequest());
				return fetch(`${API2_URL}/notifications/types?include[0]=status&page=${page}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(NotificationTypeData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(NotificationTypeFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const fetchNotificationsTypesList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(NotificationTypeRequest());
				return fetch(`${API2_URL}/notifications/types?include[0]=status&per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(NotificationTypeData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(NotificationTypeFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const notificationTypeEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(NotificationTypeRequest());
				dispatch(NotificationTypeClear());
				return fetch(`${API2_URL}/notifications/types/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(NotificationTypeEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(NotificationTypeFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const notificationTypeEditSave = (values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(values)
			};

			dispatch(NotificationTypeRequest());

			return fetch(`${API2_URL}/notifications/types${values.id ? `/${values.id}?_method=PUT`:''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message, type: "success"}));
						if(_.isEmpty(values.id)){
							history.push(`/notificaciones/editar/${json.data.id}`);
						}
						return dispatch(NotificationTypeEditData(json));
					},
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(NotificationTypeFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

const NotificationTypeRequest = () => {
	return {
		type: NOTIFICATION_TYPE_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const NotificationTypeData = (json) => {
	return {
		type: NOTIFICATION_TYPE_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const NotificationTypeEditData = (json) => {
	return {
		type: NOTIFICATION_TYPE_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const NotificationTypeClear = () => {
	return {
		type: NOTIFICATION_TYPE_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
}

const NotificationTypeFail = (error) => {
	return {
		type: NOTIFICATION_TYPE_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/notifications_types.js